import React from "react";
import "./style.css";
import rightArrowIcon from "../../../Assets/Icons/right-arrow-icon.svg";
import { paths } from "../../../Constants/paths";
import { usePatientContext } from "../../../Context/PatientContext";

const ClinicalParameters = () => {
  const { patientDetails } = usePatientContext();

  const cbcParams = patientDetails.clinicalParams?.cbc[0] || {};

  // Dynamically generate clinicalParameters array based on cbcParams
  const clinicalParameters = Object.entries(cbcParams)
    .filter(([key]) => key !== "_id")
    .map(([key, value], index) => ({
      id: index + 1,
      level: "normal", // set the level dynamically by comparing ref with value
      label: key
        .replace(/([A-Z])/g, " $1")
        .trim()
        .replace(/^./, (str) => str.toUpperCase())
        .trim(),
      value: `${value?.value || ""}`,
    }));

  /**
   * safe - green bg,
   * normal - yellow bg,
   * high - red bg
   */
  const classNamesMapping = {
    safe: "individual-param-frame safe-bg",
    normal: "individual-param-frame normal-bg",
    high: "individual-param-frame high-bg",
  };

  /**
   * Function to assign a classname depending on the level of the clinical parameter
   * @param {string} level - safe,normal,high
   * @returns - classname for individual params
   */
  const getClass = (level) => {
    return classNamesMapping[level];
  };

  return (
    // White bg frame
    <div className="clinical-parameters-container">
      <h6 className="h6-400 dark-grey">Clinical Parameters</h6>

      {/* patient summary frame that includes all boxes */}
      <div className="clinical-parameters-display">
        {clinicalParameters.map((item) => (
          // green / yellow / red box
          <div key={item.id} className={getClass(item.level)}>
            {/* normal-level / yellow bg has black color fonts
            safe-level and high-level / green bg and red bg has white color fonts */}
            {/* hence the classname is assigned based on level */}
            <p
              className={
                item.level === "normal" ? "body3 dark-grey" : "body3 white"
              }
            >
              {item.label}
            </p>
            <p
              className={
                item.level === "normal"
                  ? "body2 body2-600 dark-grey"
                  : "body2 body2-600 white"
              }
            >
              {item.value}
            </p>
          </div>
        ))}
      </div>
      <div className="navigation-frame">
        <a
          className="navigation-text"
          href={`${paths.patient.details}/${patientDetails._id}/clinical-parameters`}
        >
          View
        </a>
        <img
          src={rightArrowIcon}
          className="navigation-icon"
          alt="right-arrow-icon"
        />
      </div>
    </div>
  );
};

export default ClinicalParameters;
